import { FILTER } from '@fiverr-private/listing_lib';
import { getFilterById } from '../util';

export const getOnlineNowFilter = (filters) => getFilterById(filters, FILTER.IS_SELLER_ONLINE.ID) || null;
